import React from 'react';
import { useTranslation } from 'react-i18next';

const EXAMPLE_TONES = Object.freeze({
  drug: {
    dot: '#B91C1C',
    text: '#B91C1C',
    background: 'rgba(185,28,28,0.08)',
    border: '1px solid rgba(185,28,28,0.3)',
  },
  otc: {
    dot: '#D97706',
    text: '#B45309',
    background: 'rgba(217,119,6,0.08)',
    border: '1px solid rgba(217,119,6,0.3)',
  },
  cosmetic: {
    dot: '#16A34A',
    text: '#15803D',
    background: 'rgba(22,163,74,0.08)',
    border: '1px solid rgba(22,163,74,0.3)',
  },
});

export default function ExampleClaimsSection({ presets, onSelectExample }) {
  const { t } = useTranslation();

  return (
    <section
      className="w-full max-w-[720px] mt-8"
      aria-labelledby="example-claims-heading"
      data-testid="example-claims-section"
    >
      <div className="text-center mb-4">
        <h2
          id="example-claims-heading"
          className="text-[11px] font-extrabold uppercase tracking-widest"
          style={{ color: '#6B7280' }}
        >
          {t('exampleClaims.heading')}
        </h2>
        <p className="mt-2 text-xs leading-relaxed" style={{ color: 'var(--text-tertiary)' }}>
          {t('exampleClaims.caption')}
        </p>
      </div>
      <div className="flex flex-wrap justify-center gap-3">
        {Object.entries(presets).map(([kind, preset]) => {
          const tone = EXAMPLE_TONES[kind] || EXAMPLE_TONES.cosmetic;
          return (
            <button
              key={kind}
              type="button"
              title={t(preset.tooltipKey)}
              onClick={() => onSelectExample(kind)}
              className="flex items-center gap-2 px-4 py-2 rounded-full transition-all"
              style={{ backgroundColor: tone.background, border: tone.border }}
            >
              <span className="w-2 h-2 rounded-full" style={{ backgroundColor: tone.dot }} />
              <span className="text-sm font-semibold" style={{ color: tone.text }}>
                {t(preset.buttonKey)}
              </span>
            </button>
          );
        })}
      </div>
    </section>
  );
}
